"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = exports.className = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const react_table_1 = require("react-table");
const selectColumn_1 = require("./columns/selectColumn");
const headerCell_1 = require("./components/headerCell");
const rows_1 = require("./components/rows");
const tableRef_1 = require("./tableRef");
require("./index.scss");
exports.className = 'table';
const ReactTableFC = (props) => {
    const { setSort, setSelectedRows, tableModificators, columns, data, manualSortBy, initialState, } = props;
    const tableRef = (0, tableRef_1.useTableRef)();
    const isMultiSortDisabled = false;
    const filteredColumns = (0, react_1.useMemo)(() => columns.filter(x => !x.hidden), [columns]);
    const { 
    // useTable - hook
    getTableProps, getTableBodyProps, headerGroups, prepareRow, rows, 
    // setPageSize,
    state: { sortBy, }, } = (0, react_table_1.useTable)({
        columns: filteredColumns,
        data,
        manualSortBy,
        initialState,
        disableMultiSort: isMultiSortDisabled,
    }, react_table_1.useSortBy);
    const selectionProps = (0, selectColumn_1.useSelectedIndexes)(data, rows, setSelectedRows);
    react_1.default.useEffect(() => {
        var _a;
        const sortColumn = (_a = sortBy[0]) !== null && _a !== void 0 ? _a : null;
        const sortByType = sortColumn === null || sortColumn === void 0 ? void 0 : sortColumn.id;
        const sortOrderType = sortColumn
            // TODO move string literals DESC and ASC or change schema to boolean isDesc
            ? (sortColumn === null || sortColumn === void 0 ? void 0 : sortColumn.desc) ? 'DESC' : 'ASC'
            : undefined;
        setSort === null || setSort === void 0 ? void 0 : setSort({ sortBy: sortByType, sortOrder: sortOrderType });
    }, [sortBy, setSort]);
    const tableRowsProps = {
        rows,
        getTableBodyProps,
        prepareRow,
        selectionProps,
        tableRef,
        tableModificators,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: `${exports.className}__box` },
            react_1.default.createElement("table", { ...getTableProps() },
                react_1.default.createElement("thead", null, headerGroups.map((headerGroup, i) => (react_1.default.createElement("tr", { ...headerGroup.getHeaderGroupProps(), key: i }, headerGroup.headers.map((column, j) => {
                    const tableHeaderCellProps = {
                        column,
                        isMultiSortDisabled,
                        selectionProps,
                        tableRef,
                        tableModificators,
                    };
                    return (react_1.default.createElement(headerCell_1.TableHeaderCell, { ...tableHeaderCellProps, key: j }));
                }))))),
                react_1.default.createElement(rows_1.TableRows, { ...tableRowsProps })),
            (rows.length < 4 && rows.length !== 0) && (react_1.default.createElement("div", { className: 'spacer', style: { height: rows.length === 3 ? '30px' : '140px' } })),
            data.length === 0 && (react_1.default.createElement("div", { className: `${exports.className}__message` },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Table:NoEntries', defaultMessage: 'No entries found...' }))))));
};
class Table extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            initialState: {
                sortBy: this.props.defaultSortBy !== undefined && this.props.defaultSortOrder !== undefined ? [
                    {
                        id: this.props.defaultSortBy,
                        desc: this.props.defaultSortOrder === 'DESC',
                    },
                ] : [],
                selectedRowIds: {}, // TODO perhaps add default selected rows and pass to initial state
            },
        };
    }
    render() {
        const { ...restProps } = this.props;
        const { initialState } = this.state;
        const tableProps = {
            ...restProps,
            initialState,
        };
        return (react_1.default.createElement("div", { className: exports.className },
            react_1.default.createElement(ReactTableFC, { ...tableProps })));
    }
}
exports.Table = Table;
Table.defaultProps = {
    defaultSortBy: undefined,
    defaultSortOrder: undefined,
};
//# sourceMappingURL=index.js.map